export default "__VITE_ASSET__QVcVRNri__"